import {AdminState} from './state';
import {getStoreAccessors} from 'typesafe-vuex';
import {State} from '../state';
import {IRole} from '@/interfaces/role';
import {IExternalData} from '@/interfaces/external-data';
import {ISearchEngine} from '@/interfaces/search_engine';
import Admin from '@/views/main/admin/Admin.vue';

export const getters = {
    adminUsers: (state: AdminState) => state.users,
    adminOneUser: (state: AdminState) => (id: number) => {
        const filteredUsers = state.users.filter((item) => item.id === id);
        if (filteredUsers.length > 0) {
            return { ...filteredUsers[0] };
        }
    },
    adminForms: (state: AdminState) => state.forms,
    adminForm: (state: AdminState) => (id: number) => {
        const filteredForms = state.forms.filter((item) => item.id === id);
        if (filteredForms.length > 0) {
            return {...filteredForms[0]};
        }
    },
    adminRoles: (state: AdminState) => state.roles,
    adminRole: (state: AdminState) => (id: number) => {
        const filtered = state.roles.filter((item: IRole) => item.id === id);
        if (filtered.length > 0) {
            return {...filtered[0]};
        }
    },
    defaultRoleSettings: (state: AdminState) => state.role_settings,

    adminExternalDataList: (state: AdminState) => state.external_data_list,
    adminExternalData: (state: AdminState) => (id: number) => {
        const filtered = state.external_data_list.filter((exd: IExternalData) => exd.id === id);
        if (filtered.length > 0) {
            return {...filtered[0]};
        }
    },

    adminSearchEngines: (state: AdminState) => state.search_engines,
    adminSearchEngine: (state: AdminState) => (id: number) => {
        const filtered = state.search_engines.filter((item: ISearchEngine) => item.id === id);
        if (filtered.length > 0) {
            return {...filtered[0]};
        }
    },

    adminExternalUsers: (state: AdminState) => state.external_users,
    adminExternalUser: (state: AdminState) => (id: number) => {
        const filtered = state.external_users.filter((item) => item.id === id);
        if (filtered.length > 0) {
            return { ...filtered[0] };
        }
    },

    adminGroups: (state: AdminState) => state.groups,
    adminGroup: (state: AdminState) => (id: number) => {
        const filtered = state.groups.filter((item) => item.id === id);
        if (filtered.length > 0) {
            return { ...filtered[0] };
        }
    },

    formCategories: (state: AdminState) => state.form_categories,
    formCategory: (state: AdminState) => (id: number) => {
        const filtered = state.form_categories.filter((item) => item.id === id);
        if (filtered.length > 0) {
            return { ...filtered[0] };
        }
    },

    institutions: (state: AdminState) => state.institutions,
    institution: (state: AdminState) => (id: number) => {
        const filtered = state.institutions.filter((item) => item.id === id);
        if (filtered.length > 0) {
            return { ...filtered[0] };
        }
    },

    address: (state: AdminState) => state.address,


};

const { read } = getStoreAccessors<AdminState, State>('');

export const readAdminOneUser = read(getters.adminOneUser);
export const readAdminUsers = read(getters.adminUsers);

export const readAdminForm = read(getters.adminForm);
export const readAdminForms = read(getters.adminForms);

export const readAdminRole = read(getters.adminRole);
export const readDefaultRoleSettings = read(getters.defaultRoleSettings);
export const readAdminRoles = read(getters.adminRoles);

export const readAdminExternalData = read(getters.adminExternalData);
export const readAdminExternalDataList = read(getters.adminExternalDataList);

export const readAdminSearchEngine = read(getters.adminSearchEngine);
export const readAdminSearchEngines = read(getters.adminSearchEngines);

export const readAdminExternalUsers = read(getters.adminExternalUsers);
export const readAdminExternalUser = read(getters.adminExternalUser);


export const readAdminGroups = read(getters.adminGroups);
export const readAdminGroup = read(getters.adminGroup);


export const readFormCategory = read(getters.formCategory);
export const readFormCategories = read(getters.formCategories);


export const readInstitution = read(getters.institution);
export const readInstitutions = read(getters.institutions);

// Public
export const readAddress = read(getters.address);
